import { render, staticRenderFns } from "./PatreonIcon.vue?vue&type=template&id=02977258&"
import script from "./PatreonIcon.vue?vue&type=script&lang=js&"
export * from "./PatreonIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports